import React, { useState, useContext, useRef, useEffect } from 'react';
import UserContext, { StoreContext, UserProfileContext } from '../../../common/utils/getContext';
import { dataSender, getRoute, navigateV2 } from '../../../common/utils/router';
import { API_SERVER_URL } from '../../../common/utils/utils';
import { useRouter } from 'next/router';
import css from './CartCounter.module.scss';
import classnames from 'classnames';
import { svgSprite } from '../../../hybrid/wrappers';

const CartCounter = ({ count = 0, idProduct, funcs, price = false, type, autoCounter, customCss = {} }) => {
    const { userToken, lang, setAlertData, localization } = useContext(UserContext);
    const { profileData } = useContext(UserProfileContext);
    const { cartData, setCartData, deliveryCurrency, isLoading } = useContext(StoreContext) || {};
    const [counter, setCounter] = useState(count || '0');
    const inputRef = useRef();

    useEffect(() => {
        if (autoCounter && idProduct) {
            const count = cartData?.items?.find((prod) => prod?.product?.id === idProduct)?.quantity;
            setCounter(count || 1);
        }
    }, [autoCounter, cartData, idProduct]);

    const setCalcProduct = async (countValue) => {
        let type = 'set-product';
        if (countValue === '') {
            countValue = 1;
        }
        if (cartData.id) {
            dataSender(
                `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/${type}`,
                'POST',
                {
                    product_id: idProduct,
                    quantity: +countValue
                },
                (response) => {
                    setCounter(+countValue);
                    setCartData(response.data?.data);
                },
                (error) => {
                    if (funcs?.onError) {
                        funcs?.onError(error);
                    }
                    setAlertData({
                        type: 'error',
                        cont: true,
                        default: 'error_get_data'
                    });
                },
                userToken,
                lang,
                deliveryCurrency || profileData?.currency?.code || localization?.currency
            );
        }
        // if (!userToken) {
        //     setCantBuyModal(true);
        // }
    };

    const onInputChange = (e) => {
        const countValue = e?.target?.value;
        setCounter(countValue);
        // ставимо ширину поля від ширини контента
        const newInputWidth = String(countValue)?.length * 1.35 + 'ch';
        if (e && e.target) {
            e.target.style.width = newInputWidth;
        }
    };

    const setProduct = async () => {
        if (cartData.id) {
            dataSender(
                `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/set-product`,
                'POST',
                {
                    product_id: idProduct,
                    quantity: +counter + 1
                },
                (response) => {
                    setCounter(+counter + 1);
                    setCartData(response.data?.data);
                },
                () => {
                    setAlertData({
                        type: 'error',
                        cont: true,
                        default: 'error_get_data'
                    });
                },
                userToken,
                lang,
                deliveryCurrency || profileData?.currency?.code || localization?.currency
            );
        }
        // if (!userToken) {
        //     setCantBuyModal(true);
        // }
    };
    const router = useRouter();
    const removeProduct = async () => {
        if (cartData.id) {
            dataSender(
                `${API_SERVER_URL}/api/v1/shop/carts/${cartData.id}/remove-product?_method=DELETE`,
                'POST',
                {
                    product_id: idProduct,
                    quantity: 1
                },
                (response) => {
                    setCounter(counter - 1);
                    setCartData(response.data?.data);
                    if (router.asPath === getRoute('/store/cart') && !response?.data?.data?.items?.length) {
                        navigateV2('/store');
                    }
                },
                () => {
                    setAlertData({
                        type: 'error',
                        cont: true,
                        default: 'error_delete_data'
                    });
                },
                userToken,
                lang,
                deliveryCurrency || profileData?.currency?.code || localization?.currency
            );
        }
        // if (!userToken) {
        //     setCantBuyModal(true);
        // }
    };

    useEffect(() => {
        if (inputRef.current) {
            const newInputWidth = String(counter)?.length * 1.35 + 'ch';
            inputRef.current.style.width = newInputWidth;
        }
    }, [counter]);
    if (isLoading) return null;
    return (
        <div
            className={
                price
                    ? classnames(
                          type === 'header-general' ? css.cartItemCounterGridAdmin : css.cartItemCounter,
                          css.cartItemCounterGrid
                      )
                    : type === 'header-general'
                    ? css.cartItemCounterGridAdmin
                    : classnames(css.cartItemCounter, customCss.cartItemCounter)
            }
        >
            <div
                onClick={funcs && funcs.counter ? () => funcs.counter(idProduct, 'remove') : () => removeProduct()}
                className={classnames(css.cartItemCounterCircle, customCss.cartItemCounterCircle)}
            >
                {svgSprite('product-count-minus')}
            </div>
            <div className={css.cartItemNumber}>
                <input
                    ref={inputRef}
                    className={classnames(css.cartItemCounterValue, customCss.cartItemCounterValue)}
                    value={counter}
                    onClick={(e) => {
                        e.target.select();
                    }}
                    type='number'
                    onBlur={(e) => {
                        funcs && funcs.counter
                            ? funcs.counter(idProduct, 'change', +e.target.value)
                            : setCalcProduct(+e.target.value, e);
                    }}
                    onChange={onInputChange}
                />
            </div>
            <div
                onClick={funcs && funcs.counter ? () => funcs.counter(idProduct, 'set') : () => setProduct()}
                className={classnames(css.cartItemCounterCircle, customCss.cartItemCounterCircle)}
            >
                {svgSprite('product-count-plus')}
            </div>
        </div>
    );
};
export default CartCounter;
// type = 'remove-product?_method=DELETE'
